import { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { SlPencil } from "react-icons/sl";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ModalAlt from "../../components/modal/ModalAlt";
import { ERROR_MSG } from "../../constants/common";
import { RESET_LOADER, SET_LOADER } from "../../constants/contexConstant";
import { connectionTypeToCategory } from "../../constants/InvestmentConstant";
import {
    GET_PLANT_BY_ID_ENDPOINT,
    PROPOSAL_DOCUMENT_META_ENDPOINT,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import cn from "../../lib/cn";
import {
    locationLight,
    starCircle,
    statusImages,
    whiteApartment,
} from "../../resources/js/icons";
import request from "../../services/request";
import Counter from "../../shared/animation/typography/Counter";
import Container from "../../shared/Container";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import BottomDrawer from "../../shared/ui/Drawer/BottomDrawer";
import TextField from "../../shared/ui/Form/TextField";
import Tag from "../../shared/ui/tag/Tag";
import ProjectForm from "./forms/ProjectForm";
import ProposalContent, { panelTypes } from "./ProposalContent";
const parseGst = (gstValue) => {
    if (typeof gstValue === "number" && !isNaN(gstValue)) {
        return gstValue;
    }
    if (typeof gstValue === "string") {
        const cleaned = gstValue.replace(/[₹,\s]/g, "");
        const parsed = parseInt(cleaned, 10);
        return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
};
const buildTableData = (
    existingItems,
    currentproposalData,
    isLease,
    solarPlantSize
) => {
    let additional = existingItems?.additionalItems || [];
    let gst = parseGst(currentproposalData?.gst);

    let totalWithAdditional =
        (additional?.length && additional?.length !== 0
            ? additional.reduce((prev, el) => prev + parseInt(el.itemPrice), 0)
            : 0) +
        parseInt(parseGst(currentproposalData?.solarPlantSizeCost)) +
        gst;

    let initialData = isLease
        ? [
              {
                  Description: "Fixed Monthly Rental",
                  "Plan Details": (
                      <P className="font-semibold">
                          ₹ {currentproposalData?.fixedMonthlyRental}
                      </P>
                  ),
              },
              {
                  Description: "Bank Guarantee",
                  "Plan Details": (
                      <P className="font-semibold">
                          {currentproposalData?.bankGuarantee}
                      </P>
                  ),
              },
              {
                  Description: "Savings on Existing Bills",
                  "Plan Details": (
                      <P className="font-semibold">
                          {currentproposalData?.savingsOnExistingBill} %
                      </P>
                  ),
              },
          ]
        : [
              {
                  Description: (
                      <P className="text-secondary ">
                          Solar Plant Cost:
                          <span className="font-medium">
                              {`${solarPlantSize} KWp`}
                          </span>{" "}
                      </P>
                  ),

                  "Plan Details": (
                      <P className="font-semibold text-nowrap">
                          {currentproposalData?.solarPlantSizeCost}
                      </P>
                  ),
              },
              {
                  Description: "GST @ 13.8%",
                  "Plan Details": (
                      <P className="font-semibold">₹ {gst?.toLocaleString()}</P>
                  ),
              },

              ...(additional?.length && additional.length !== 0
                  ? additional.map((item) => ({
                        Description: (
                            <P className="text-secondary 2xl:text-base ">
                                {item.itemDescription}
                                {item.itemGst && Number(item.itemGst) !== 0 && (
                                    <span className="text-primary text-xs block">
                                        GST @{" "}
                                        <span className=" font-medium">
                                            {item.itemGst}%
                                        </span>
                                    </span>
                                )}
                            </P>
                        ),
                        "Plan Details": (
                            <P className="font-semibold">
                                ₹ {parseInt(item.itemPrice).toLocaleString()}
                            </P>
                        ),
                    }))
                  : []),

              {
                  Description: (
                      <P className="text-secondary font-semibold xl:text-lsm">
                          Total Amount
                      </P>
                  ),
                  "Plan Details": (
                      <P className="font-semibold">
                          ₹ {totalWithAdditional.toLocaleString()}
                      </P>
                  ),
              },
          ];

    return initialData;
};

const Proposal = () => {
    const [dis, setDis] = useState(true);
    const [success, setSuccess] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);
    const { id } = useParams();
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [currentproposalData, setCurrentProposalData] = useState(null);
    const [proposalIds, setProposalIds] = useState([]);
    const [costKw, setCostKw] = useState(0);
    const [options, setOptions] = useState(["Purchase", "Lease"]);
    const [connectionType, setConnectionType] = useState("Residential Society");
    const [currentPanelType, setCurrentPannelType] = useState(
        connectionType === "Residential Society" ||
            connectionType === "Individual Homes"
            ? panelTypes[0]
            : panelTypes[1]
    );

    const [solarPlantSize, setSolarPlantSize] = useState(0);
    const [subsidyAmount, setSubsidyAmount] = useState(0);
    const [GST, setGST] = useState(0);

    const [formData, setFormData] = useState({});
    const { state, dispatch } = useContextState();

    const [totalUnits, setTotalUnits] = useState(null);
    const [consumersBill, setConsumersBill] = useState(null);
    const [admins, setAdmins] = useState([]);
    const [url, setUrl] = useState("");
    const handleSelectedProposalId = (item) => {
        setCurrentProposalId(item);
    };
    const handleAdmins = (admins) => {
        setAdmins(admins?.admins);
        setUrl(admins?.url);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const endpoint = `${GET_PLANT_BY_ID_ENDPOINT}/${id}`;
                const data = await request.authGet({ endpoint });
                setFormData(data?.data?.plant);
                handleSelectedProposalId(data?.data?.plant?.proposalIds[0]);
                handleAdmins(data?.data?.plant?.admins);
                setProposalIds(data?.data?.plant?.proposalIds);
                setConnectionType(
                    connectionTypeToCategory[data?.data?.plant?.connectionType]
                );
                if (
                    connectionTypeToCategory[
                        data?.data?.plant?.connectionType
                    ] === connectionTypeToCategory.INDIVIDUAL_HOMES ||
                    connectionTypeToCategory[
                        data?.data?.plant?.connectionType
                    ] === connectionTypeToCategory.INDUSTRIAL
                ) {
                    setOptions(["Purchase"]);
                }
            } catch (error) {
                dispatch({ type: RESET_LOADER });
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        setTotalUnits(currentproposalData?.unitConsumption);
        setConsumersBill(parseGst(currentproposalData?.averageMonthlyBill));
    }, [currentTab, currentproposalData]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const endpoint = `${PROPOSAL_DOCUMENT_META_ENDPOINT}/${id}/${currentProposalId}`;

                try {
                    dispatch({ type: SET_LOADER });
                    const data = await request.authPost({
                        endpoint: endpoint,
                        body: {
                            type: options[currentTab]?.toLowerCase(),
                            isSubsidy: currentPanelType?.subsidy,
                        },
                    });
                    dispatch({ type: RESET_LOADER });
                    setCurrentProposalData(data?.data?.data);

                    if (currentPanelType?.subsidy) {
                        setSubsidyAmount(
                            parseGst(data?.data?.data?.governmentSubsidy)
                        );
                    }
                } catch (error) {
                    dispatch({ type: RESET_LOADER });
                }
            } catch (error) {
                dispatch({ type: RESET_LOADER });
            }
        };

        if (currentProposalId) {
            fetchData();
        }
    }, [currentProposalId, currentPanelType, currentTab]);

    useEffect(() => {
        if (totalUnits > 0) {
            const size = Number(totalUnits / 120);
            setSolarPlantSize(size.toFixed(2));
        }
    }, [consumersBill, totalUnits]);

    let isLease = options[currentTab] === "Lease";

    const updatePropertyDetailsHandler = async (values) => {
        const changedFields = {};
        const initial = {
            projectName: formData.propertyName,
            address:
                formData.siteAddress /* @TODO => this will be newly address  @habib610 Tue June 10,2025 */,
            city: formData.city,
            state: formData.state,
            pincode: formData.pincode,
            latitude: formData.latitude,
            longitude: formData.longitude,
        };

        Object.keys(initial).forEach((key) => {
            if (values[key] !== undefined && values[key] !== initial[key]) {
                changedFields[key] = values[key];
            }
        });

        if (Object.keys(changedFields).length === 0) {
            toast.error("No changes made to update");
            return;
        }

        try {
            const res = await request.authPut({
                endpoint: `${GET_PLANT_BY_ID_ENDPOINT}/update-plant-details/${id}`,
                body: changedFields,
            });

            if (res?.data?.Plant?.propertyName) {
                setFormData((prev) => ({
                    ...prev,
                    propertyName: res?.data?.Plant?.propertyName,
                    siteAddress:
                        res?.data?.Plant
                            ?.siteAddress /* @TODO => add adddress here @habib610 Tue June 10,2025 */,
                    city: res?.data?.Plant?.city,
                    state: res?.data?.Plant?.state,
                    pincode: res?.data?.Plant?.pincode,
                    latitude: res?.data?.Plant?.latitude,
                    longitude: res?.data?.Plant?.longitude,
                }));
            }

            setDis((prev) => !prev);

            toast.success(
                typeof res?.message === "string"
                    ? res.message
                    : "Plant details updated successfully"
            );
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            setDis((prev) => !prev);
        }
    };
    let existingItems = currentproposalData;
    const history = useHistory();

    return (
        <Container className="bg-blue-700 pt-[7rem] lg:py-[10rem] mx-0 px-0 min-w-full  lg:container lg:overflow-y-scroll   min-h-screen  lg:h-full lg:bg-white">
            <div
                className=" hidden lg:flex items-center gap-1 py-1"
                role="button"
                onClick={() => history.goBack()}
            >
                <P>
                    <GoArrowLeft />
                </P>
                <P> Dashboard</P>
            </div>
            <Container className="flex my-1.5  min-w-full justify-between items-center lg:hidden">
                {options.map((option, index) => (
                    <div
                        key={option}
                        role="button"
                        onClick={() => setCurrentTab(index)}
                    >
                        <P
                            className={cn(
                                "text-gray-370 flex items-center gap-1",
                                {
                                    "text-white border-b-2 border-b-blue pb-1 font-medium":
                                        currentTab === index,
                                }
                            )}
                        >
                            {option}
                            {option === "Lease" && admins && (
                                <img
                                    src={starCircle}
                                    alt="Lease Enabled"
                                    className="w-2"
                                />
                            )}
                        </P>
                    </div>
                ))}
            </Container>

            <Container className=" my-1 min-w-full lg:hidden">
                <div className="bg-blue-550  p-1.5   md:m-auto  md:py-2 gap-2 flex flex-col rounded-3xl  justify-center  items-center">
                    <div className="flex w-full flex-col gap-1 justify-stretch">
                        <div className="flex justify-between items-center gap-2">
                            <div className=" flex items-center gap-1 mb-1">
                                <img
                                    src={whiteApartment}
                                    alt="whiteApartment"
                                    className="w-3 h-3"
                                />
                                <div className=" w-full">
                                    <TextField
                                        label={""}
                                        value={formData?.propertyName}
                                        size={
                                            "w-full md:min-w-[24rem] bg-none !bg-transparent"
                                        }
                                        name="name"
                                        disabled={true}
                                        placeholder=""
                                        wrapper={
                                            "md:h-[5rem] gap-0.5 px-0 !border-none !bg-none !bg-transparent"
                                        }
                                        inputWrapper="rounded-l-md px-0 py-0  text-xs !text-white !border-none !bg-none !bg-transparent text-clip  line-clamp-1"
                                        type="text"
                                        icon={<SlPencil />}
                                        iconWrapperClass={`text-xs !border-none text-white flex items-center rounded-r-md   `}
                                        iconChange={() => {
                                            setDis((prev) => !prev);
                                        }}
                                    />
                                    <p className="text-gray-140">
                                        {connectionType}
                                    </p>
                                </div>
                            </div>
                            <Tag
                                text={formData?.plantId}
                                icon={
                                    <img
                                        src={statusImages.hot}
                                        alt="fire"
                                        className="h-2"
                                    />
                                }
                                className={" bg-gray-100 rounded-xl p-0.2"}
                                textClass={
                                    "text-secondary  gap-0.5 text-nowrap !text-xs"
                                }
                            />
                        </div>
                        <p className="text-white flex items-start gap-0.8  text-xs line-clamp-1">
                            <img
                                src={locationLight}
                                alt="locationLight"
                                className="mt-0.2"
                            />
                            {formData?.siteAddress}
                        </p>
                    </div>
                    <div className="flex w-full items-center justify-between gap-1">
                        <div className="flex flex-col items-center">
                            <H4 className="text-xs xs:text-sm sm:text-nowrap text-white md:text-base xl:text-base ">
                                ₹{" "}
                                <Counter
                                    start={Number(consumersBill) - 200}
                                    value={consumersBill}
                                />
                            </H4>
                            <P className="text-xs text-nowrap text-white md:text-sm xl:text-sm ">
                                Bill With Solar
                            </P>
                        </div>
                        <div
                            className={`bg-blue-200 w-0.1 min-h-[5rem]  max-h-[6rem]
                                                            `}
                        />
                        <div className="flex flex-col items-center">
                            <H4 className="text-xs xs:text-sm sm:text-nowrap text-white md:text-base xl:text-base ">
                                {solarPlantSize}kWp
                            </H4>
                            <P className=" text-xs text-nowrap text-white md:text-sm xl:text-sm">
                                Solar Plant Size
                            </P>
                        </div>
                    </div>
                </div>
                {subsidyAmount > 0 && (
                    <div className="flex text-center justify-center items-center p-0.2  md:mx-auto rounded-xl lg:rounded-none mb-2 bg-green-100">
                        <P className="text-green-200 text-xs md:text-sm xl:text-sm">
                            Society will receive {subsidyAmount} govt. subsidy
                        </P>
                    </div>
                )}
            </Container>

            <ProposalContent
                currentTab={currentTab}
                currentProposalId={currentProposalId}
                proposalData={proposalIds}
                connectionType={connectionType}
                selected={currentProposalId}
                admins={admins}
                url={url}
                handleAdmins={handleAdmins}
                tableData={buildTableData(
                    existingItems,
                    currentproposalData,
                    isLease,
                    solarPlantSize
                )}
                setGST={setGST}
                dis={dis}
                setDis={setDis}
                propertyName={formData?.propertyName}
                subsidyAmount={subsidyAmount}
                formData={formData}
                solarPlantSize={solarPlantSize}
                consumerBill={consumersBill}
                options={options}
                handleSelectedProposalId={handleSelectedProposalId}
                setCurrentTab={setCurrentTab}
                currentPanelType={currentPanelType}
                setCurrentPannelType={setCurrentPannelType}
            />
            <div className="hidden lg:block">
                <ModalAlt
                    isOpen={!dis}
                    backgroundColor="white"
                    contentClass={"bg-white"}
                    onClose={() => {
                        setDis((prev) => !prev);
                    }}
                    innerTimes={false}
                    topPadding={"20px"}
                >
                    <ProjectForm
                        initialValues={{
                            projectName: formData?.propertyName || "",
                            address:
                                formData?.siteAddress ||
                                "" /* @TODO => use newly added address @habib610 Tue June 10,2025 */,
                            city: formData?.city || "",
                            state: formData?.state || "",
                            pincode: formData?.pincode || "",
                            latitude: formData.latitude,
                            longitude: formData.longitude,
                        }}
                        onSubmit={updatePropertyDetailsHandler}
                    />
                </ModalAlt>
            </div>
            <div className="lg:hidden">
                <BottomDrawer
                    isOpen={!dis}
                    contentClass="min-h-[75vh] rounded-t-4 bg-white"
                    childrenClassName="bg-white"
                    className="z-[102]"
                    onClick={() => setDis((prev) => !prev)}
                >
                    <div className="bg-white  bottom-0">
                        <ProjectForm
                            initialValues={{
                                projectName: formData?.propertyName || "",
                                address: formData?.siteAddress || "",
                                city: formData?.city || "",
                                state: formData?.state || "",
                                pincode: formData?.pincode || "",
                                latitude: formData.latitude,
                                longitude: formData.longitude,
                            }}
                            onSubmit={updatePropertyDetailsHandler}
                        />
                    </div>
                </BottomDrawer>
            </div>
        </Container>
    );
};

export default Proposal;
